// extracted by mini-css-extract-plugin
export var tosLink = "_c1-0";